module.exports = __webpack_public_path__ + "media/images/icons/ban_green-0e1deee78f413c1d7b858f4050bd8be4.svg";